import React from 'react';

const PgoneTheme = {
  headerLogo: {
    src: '/themes/theme/pgone/logo.png',
    alt: 'PG One Logo',
    size: 50,
  },
  darkLogo: {
    src: '/themes/theme/pgone/logo.png',
    alt: 'PG One Logo',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img height="120" src="/themes/theme/pgone/logo.png" alt="PG One Logo" />
      <br /><br />
      <h3>PG One Influencers</h3>
    </div>
  ),
  shareSite: 'https://pgoner.dyzio.co',
};

export default PgoneTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/pgone.js
 **/